import { FC } from 'react'

import styled from 'styled-components'
import {
  compose,
  color,
  space,
  SpaceProps,
  TypographyProps,
  layout,
  LayoutProps,
  flexbox,
  FlexboxProps,
  border,
  shadow,
} from 'styled-system'

import { StyledProps } from '../theme'
import { ColorsProps } from '../theme/colors'
import { BorderProps } from '../theme/borders'

import { Box } from '../box'

type Props = ColorsProps &
  SpaceProps &
  StyledProps &
  TypographyProps &
  LayoutProps &
  FlexboxProps &
  BorderProps

export const Divider: FC<Props> = styled(Box)<Props>(
  compose(layout, space, color, flexbox, border, shadow)
)

Divider.defaultProps = {
  bg: 'neutral-light-32',
  height: '1px',
}

export const VerticalDivider: FC<Props> = styled(Box)<Props>(
  compose(layout, space, color, flexbox, border, shadow)
)

VerticalDivider.defaultProps = {
  bg: 'neutral-light-32',
  height: '100%',
  width: '1px',
  flexShrink: 0,
}
